import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../../utils/api';

const money = (n) =>
  `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/**
 * BusinessTdsCard — TDS this customer deducted, per financial year.
 * Hidden when there is none, or when the viewer has no TDS permission (403).
 */
const BusinessTdsCard = ({ businessId, cardStyle }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let dead = false;
    setData(null);
    API.get('/tds/summary', { params: { businessId } })
      .then((r) => { if (!dead) setData(r.data); })
      .catch(() => {});
    return () => { dead = true; };
  }, [businessId]);

  if (!data || !data.totals || data.totals.count === 0) return null;

  return (
    <div style={cardStyle}>
      <div style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 12 }}>🧾 TDS deducted by this customer</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.84rem' }}>
        <thead>
          <tr>
            {['Financial year', 'TDS deducted', 'Certificates received', 'Pending'].map((h, i) => (
              <th key={h} style={{ textAlign: i === 0 ? 'left' : 'right', padding: '6px 8px', fontSize: '0.72rem', color: 'var(--text-muted)', textTransform: 'uppercase', borderBottom: '1px solid var(--border)' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.byFy.map((r) => (
            <tr key={r.fy}>
              <td style={{ padding: '7px 8px', fontWeight: 600 }}>{r.fy}</td>
              <td style={{ padding: '7px 8px', textAlign: 'right', color: '#b45309', fontWeight: 700 }}>{money(r.total)}</td>
              <td style={{ padding: '7px 8px', textAlign: 'right', color: '#16a34a' }}>{money(r.received)}</td>
              <td style={{ padding: '7px 8px', textAlign: 'right', color: r.pending > 0 ? '#dc2626' : '#9ca3af' }}>{money(r.pending)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: 10, fontSize: '0.78rem' }}>
        <Link to="/admin/tds" style={{ color: 'var(--primary)', fontWeight: 600 }}>Open TDS Register →</Link>
      </div>
    </div>
  );
};

export default BusinessTdsCard;
